export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function apiRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init.headers ?? {})
    }
  });

  const payload = (await response.json().catch(() => ({}))) as { error?: string };

  if (!response.ok) {
    throw new ApiError(payload.error ?? "Request failed.", response.status);
  }

  return payload as T;
}

export function adminRequest<T>(pin: string, path: string, init: RequestInit = {}) {
  return apiRequest<T>(path, {
    ...init,
    headers: {
      "X-Admin-Pin": pin,
      ...(init.headers ?? {})
    }
  });
}

export function money(cents: number, currency = "USD") {
  const label = currency.trim() || "USD";
  const amount = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(cents / 100);

  return `${label} ${amount}`;
}
